module.exports = __webpack_public_path__ + "static/img/Fiskor_logo.b2cbd63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Fiskor_logo.png
// module id = uXu1
// module chunks = 0